import React, { useState, useCallback, useRef } from 'react';
import { useScreenSize } from '../../../../../utils/media-query';
import { PopupForm, PopupWarn } from '../../../../script/components/popup/popup';
import { FormBool, FormDate, FormText } from '../../../../script/components/form/form-item';
import { GroupItem } from 'devextreme-react/cjs/form';
import { AddingGrid } from '../../../../script/components/data-grid/data-grid-body/grid-bodys';
import { CommCol, DateCol } from '../../../../script/components/data-grid/data-grid-column/grid-column';
import { fwUtil } from '../../../../script/util';

const defaultData = {
    ware_date: fwUtil.date.getsText.date(),
    stoc_loca: '',
    insp_okey: true,
};

const pproDataSource = fwUtil.grid.get.dataSource();

export function PproFullRegiInsert(props) {
    const {
        mainGrid,
        mainRefresh, subsRefresh,
        insertApi,
        visible, hiding
    } = props;

    const { isXSmall, isSmall, isMedium } = useScreenSize();
    const [loading, setLoading] = useState(false);
    // 데이터
    const [data, setData] = useState(defaultData);
    const dataUpdate = useCallback((e) => setData(e), [setData]);
    // 발주 그리드
    const pproRef = useRef(null);
    // 확인 알림
    const [alertVisible, setAlertVisible] = useState(false);
    const alertHide = useCallback(() => setAlertVisible(false), []);   

    // 열릴 때
    const onShowing = useCallback(async() => {
        const selectedRowKey = fwUtil.grid.get.lKey(mainGrid);
        if (!selectedRowKey) {
            fwUtil.aler.toast.s1Erro();
            hiding();
        } else {
            pproDataSource.store().insert({ init: true }).then(() => pproDataSource.reload());
            const pproSelected = mainGrid.current.instance.getSelectedRowsData() || [];
            for (const ppro of pproSelected) {
                const newData = {
                    ppro_numb: ppro.ppro_numb || '', 
                    clie_name: ppro.clie_name || '', 
                    pdel_date: ppro.pdel_date || null, 
                    pays_cond: ppro.pays_cond || '', 
                    deli_plac: ppro.deli_plac || '', 
                    ppro_remk: ppro.ppro_remk || '', 
                    damd_name: ppro.damd_name || '', 
                    ppro_date: ppro.ppro_date || null, 
                    ppro_usag: ppro.ppro_usag || '', 
                    ppro_stat: ppro.ppro_stat || '', 
                };
                pproDataSource.store().insert(newData);
            }
            
            pproDataSource.reload();
            dataUpdate(defaultData);
        }
    }, [hiding, mainGrid, dataUpdate]);

    // 수정
    const updateField = (field) => (value) => {
        if (!data) return;

        dataUpdate({ ...data, [field]: value });
    };		

    // 제출
    const onSubmit = useCallback(async () => {
        setLoading(true);
        const pproData = pproRef?.current?.instance?.getDataSource()?.items();
        const postPproData = pproData.map((item) => ({
            pproNumb: item.ppro_numb || "",  
            wareDate: data.ware_date || fwUtil.date.getsText.date(),       
            stocLoca: data.stoc_loca || '',
            inspOkey: data.insp_okey || false,
        }));        
        const postData = {
            setaMaps: postPproData || [],
        };

        const refresh = () => {
            mainRefresh();
            subsRefresh();
        };

        const allHiding = () => {
            alertHide();
            hiding();
        }

        await fwUtil.apis.action(insertApi, postData, refresh, allHiding);
        setLoading(false);
    }, [data, insertApi, mainRefresh, subsRefresh, hiding, alertHide, pproRef]);

    return (
        <>
        <PopupForm
            title={'전체입고'}       
            type={'입고'}
            loading={loading}
            visible={visible}
            showing={onShowing}
            hiding={hiding}
            onSubmit={() => setAlertVisible(true)}
            width={isXSmall ? 300 : isSmall ? 600 : isMedium ? 900 : '90%' } 
            additionalChild={
                <div className='fw-additional-child-box fw-flex-box col'>
                    <AddingGrid
                        title={'발주목록'}
                        gridRef={pproRef} 
                        gridDataSource={pproDataSource}
                    >
                        {CommCol({ dataField: "ppro_numb", caption: "발주번호" })} 
                        {CommCol({ dataField: "clie_name", caption: "업체명" })} 
                        {DateCol({ dataField: "pdel_date", caption: "납품일자" })} 
                        {CommCol({ dataField: "pays_cond", caption: "지불형태" })} 
                        {CommCol({ dataField: "deli_plac", caption: "납품장소" })} 
                        {CommCol({ dataField: "ppro_remk", caption: "특기사항" })} 
                        {CommCol({ dataField: "damd_name", caption: "발주담당자" })} 
                        {DateCol({ dataField: "ppro_date", caption: "발주일자" })} 
                        {CommCol({ dataField: "ppro_usag", caption: "용도" })} 
                        {CommCol({ dataField: "ppro_stat", caption: "진행상태" })}   
                    </AddingGrid>
                </div>
            }         
        >
            <GroupItem colCount={isXSmall ? 1 : isSmall ? 2 : isMedium ? 3 : 4}>
                {FormDate({ value: data.ware_date, onValueChange: updateField('ware_date'), label: '등록일자' })}
                {FormText({ value: data.stoc_loca, onValueChange: updateField('stoc_loca'), label: '저장위치', required: true })}
                <GroupItem colCount={2}>
                    {FormBool({ value: data.insp_okey, onValueChange: updateField('insp_okey'), label: '입고검사 확인' })}
                </GroupItem>
            </GroupItem>
        </PopupForm>   
        <PopupWarn
            visible={alertVisible}
            hiding={alertHide}
            confirm={onSubmit}
            warning={"전체입고 시 해당 발주의 모든 발주자재가 입고처리됩니다."}
            message={'해당 발주를 전체입고 하시겠습니까?'}
        />  
        </>
    );
}